import * as React from "react";

type CurrencyProps = {
  value: string; // unsure if this is fully accurate?
  as?: React.ElementType;

  [restProps: string]: any;
} & FormatCurrencyOptions;

// TODO: This needs to be improved I think. We should include
// separators (commas), and support other currencies.
export function Currency(props: CurrencyProps) {
  const { value, as: Component = "span", ...restProps } = props;
  return <Component {...props}>${formatCurrency(value, restProps)}</Component>;
}

type FormatCurrencyOptions = {
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
  forceMinimumFraction?: boolean;
};

export const formatCurrency = (value: string, options: FormatCurrencyOptions = {}) => {
  const locale = undefined; // Use the host default language.

  const {
    maximumFractionDigits = 2,
    minimumFractionDigits = 0,
    forceMinimumFraction = false,
  } = options;

  const toLocaleStringOptions: Intl.NumberFormatOptions = {
    maximumFractionDigits,
    minimumFractionDigits,
  };

  let numberValue = parseFloat(value);

  if (isNaN(numberValue)) {
    numberValue = 0.0;
  }

  if (!Number.isInteger(numberValue) && !forceMinimumFraction) {
    toLocaleStringOptions["minimumFractionDigits"] = 2;
  }

  return numberValue.toLocaleString(locale, toLocaleStringOptions);
};
